export default "__VITE_ASSET__be0fb947__"